import { Layout, Tabs } from 'antd'

import { GLOBAL_CLIENT } from '../../helpers/GlobalClient'
import { useTranslation } from 'react-i18next'
import 'moment/locale/vi'
import { observer } from 'mobx-react-lite'
import { useStore } from '../../hooks'
import { tabConfigPrice } from '../../helpers/constants'
import ContentFee from './Content'
import { useEffect } from 'react'
import ExportToCSV from './ExportToCSV'
const { Content } = Layout
const TabPane = Tabs.TabPane

const PriceManagement = observer((props: any) => {
   const { t } = useTranslation()
   const CommonConfigStore = useStore('CommonConfigStore')
   const UserStore = useStore('UserStore')

   const onChangeTab = (key: string) => {
      CommonConfigStore.setActiveKeyMain(key)
   }

   useEffect(() => {
      if (CommonConfigStore.activeKeyMain == tabConfigPrice.seller) {
         //get list seller neu chua co
         if (!UserStore.listSeller.rows || UserStore.listSeller.rows.length == 0) {
            UserStore.getSeller()
         }
      } else if (CommonConfigStore.activeKeyMain == tabConfigPrice.fulfillment) {
         if (!UserStore.listFulfillment.rows || UserStore.listFulfillment.rows.length == 0) {
            UserStore.getFulfillment()
         }
      } else {
         if (!UserStore.listParner.rows || UserStore.listParner.rows.length == 0) {
            UserStore.getPartner()
         }
      }
   }, [CommonConfigStore.activeKeyMain])
   return (
      <Content {...props}>
         <div style={{ position: 'fixed', top: '10px', zIndex: 999, right: '16px' }}>
            <ExportToCSV {...props} />
         </div>

         <Tabs activeKey={CommonConfigStore.activeKeyMain} onChange={onChangeTab}>
            <TabPane tab={t(GLOBAL_CLIENT.mSeller)} key={tabConfigPrice.seller}>
               <ContentFee
                  {...props}
                  idTab={tabConfigPrice.seller}
                  key={tabConfigPrice.seller}
                  listFilter={[{ id: '', name: 'All' }, ...UserStore.listSeller.rows]}
               />
            </TabPane>

            <TabPane tab={t(GLOBAL_CLIENT.mFulfillment)} key={tabConfigPrice.fulfillment}>
               <ContentFee
                  {...props}
                  idTab={tabConfigPrice.fulfillment}
                  key={tabConfigPrice.fulfillment}
                  listFilter={[{ id: '', name: 'All' }, ...UserStore.listFulfillment.rows]}
               />
            </TabPane>
            {/* <TabPane tab={'Partner'} key={tabConfigPrice.parner}>
               <ContentFee
                  {...props}
                  idTab={tabConfigPrice.parner}
                  key={tabConfigPrice.parner}
                  listFilter={[{ id: '', name: 'All' }, ...UserStore.listParner.rows]}
               />
            </TabPane> */}
         </Tabs>
      </Content>
   )
})

export default PriceManagement
